export enum DoorType {
  CITY_DELIVERY = "CITY_DELIVERY",
  LOADING = "LOADING",
  OVERAGES = "OVERAGES",
  RACK = "RACK",
  STAGING = "STAGING",
  SHORTAGES = "SHORTAGES",
  UNLOADING = "UNLOADING",
}

export const DoorTypeLabels: Record<DoorType, string> = {
  [DoorType.CITY_DELIVERY]: "City Delivery",
  [DoorType.LOADING]: "Loading",
  [DoorType.OVERAGES]: "Overages",
  [DoorType.RACK]: "Rack",
  [DoorType.STAGING]: "Staging",
  [DoorType.SHORTAGES]: "Shortages",
  [DoorType.UNLOADING]: "Unloading",
};

export enum DoorUsage {
  CITY_RACK = "CITY_RACK",
  LOCAL_ONLY = "LOCAL_ONLY",
  MOBILE_STG = "MOBILE_STG",
  NON_PERM = "NON_PERM",
  OVERAGE = "OVERAGE",
  PERMANENT = "PERMANENT",
  WMS = "WMS",
  SHORTAGE = "SHORTAGE",
  WILL_CALLS = "WILL_CALLS",
  LOST = "LOST",
}

export const DoorUsageLabels: Record<DoorUsage, string> = {
  [DoorUsage.CITY_RACK]: "City Rack",
  [DoorUsage.LOCAL_ONLY]: "Local Only",
  [DoorUsage.MOBILE_STG]: "Mobile Staging",
  [DoorUsage.NON_PERM]: "Non Permanent",
  [DoorUsage.OVERAGE]: "Overage",
  [DoorUsage.PERMANENT]: "Permanent",
  [DoorUsage.WMS]: "WMS",
  [DoorUsage.SHORTAGE]: "Shortage",
  [DoorUsage.WILL_CALLS]: "Will Calls",
  [DoorUsage.LOST]: "Lost",
};

export enum DoorStatus {
  HD_RAIL_FREIGHT = "HD_RAIL_FREIGHT",
  LINEHAUL = "LINEHAUL",
  OVERWEIGHT = "OVERWEIGHT",
  RETURN_ON_DELIVERY = "RETURN_ON_DELIVERY",
  UNDERWEIGHT = "UNDERWEIGHT",
}

export const DoorStatusLabels: Record<DoorStatus, string> = {
  [DoorStatus.HD_RAIL_FREIGHT]: "HD Rail Freight",
  [DoorStatus.LINEHAUL]: "Trailer at Door is Linehaul",
  [DoorStatus.OVERWEIGHT]: "Trailer at Door is Overweight",
  [DoorStatus.RETURN_ON_DELIVERY]: "Return on Delivery Manifest",
  [DoorStatus.UNDERWEIGHT]: "Underweight Trailer",
};
